import {Component, NgModule, ViewChild, ViewContainerRef, ComponentFactoryResolver , Input } from '@angular/core'
import { SafeResourceUrl, 
         DomSanitizer } from '@angular/platform-browser';
         
@Component({
  selector: 'tn-google-map',
  templateUrl: './tngooglemap.html'
})

export class TnGoogleMap {
  @Input() geolocationaddress: string;
  
  destinationURL: string = "https://www.google.com/maps/embed/v1/place?key=";
  destinationKey: string = "AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U";

  GeoAddress: any;

  constructor(public sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.GeoAddress = this.destinationURL + this.destinationKey + '&q=' + this.geolocationaddress;
        this.GeoAddress = this.sanitizer.bypassSecurityTrustStyle(this.GeoAddress);
    }


}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tngooglemap/tngooglemap.component.ts